import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-list-paginator',
  standalone: true,
  imports: [
    MatPaginatorModule
  ],
  templateUrl: './list-paginator.component.html',
  styleUrl: './list-paginator.component.scss'
})
export class ListPaginatorComponent {
  @Input() length = 0;
  @Input() pageSize = 12;
  @Input() pageIndex = 0;
  @Input() pageSizeOptions: number[] = [12, 25, 50, 100];
  @Input() showFirstLastButtons = true;
  @Input() hidePageSize = false;
  @Input() disabled = false;

  @Output() page = new EventEmitter<PageEvent>();

  onPageChange(event: PageEvent) {
    this.page.emit(event);
  }
}